module.exports = __webpack_public_path__ + "img/bg_function06_2_t.0efd2cfa.png";